import React from 'react';
import { FaHeart, FaShoppingBag, FaBolt } from 'react-icons/fa';
import './CartActionsSection.css';

interface CartActionsSectionProps {
  availableQuantity: number;
  selectedQuantity: number;
  favoriteCount: number;
  isFavorite: boolean;
  onToggleFavorite: () => void;
  onAddToCart: () => void;
  onBuyNow: () => void;
}

const CartActionsSection: React.FC<CartActionsSectionProps> = ({
  availableQuantity,
  selectedQuantity,
  favoriteCount,
  isFavorite,
  onToggleFavorite,
  onAddToCart,
  onBuyNow
}) => {
  const isDisabled = availableQuantity === 0 || selectedQuantity === 0;
  return (
    <div className="modern-actions-card">
      {/* Primary Interaction Area */}
      <div className="main-button-group">
        <button 
          className="btn-primary-black" 
          onClick={onAddToCart} 
          disabled={isDisabled}
        >
          <FaShoppingBag size={14} />
          <span>Add to Bag</span>
        </button>
        
        <button 
          className="btn-secondary-white" 
          onClick={onBuyNow} 
          disabled={isDisabled}
        >
          <FaBolt size={14} />
          <span>Buy Now</span>
        </button>
      </div>

      {/* Social / Favorites */}
      <div className="interaction-footer">
        <button 
          className={`favorite-toggle ${isFavorite ? 'is-active' : ''}`} 
          onClick={onToggleFavorite}
        >
          <FaHeart className="heart-icon" />
          <span>{isFavorite ? 'Saved to Wishlist' : 'Save for Later'}</span>
        </button>
        <p className="social-proof">{favoriteCount} others loved this</p>
      </div>
    </div>
  );
};

export default CartActionsSection;